import { Route, Routes } from 'react-router';
import Home from './routes/home';
import Create from './routes/create';
import OrganizationContentList from '@/components/content/organization-content-list/organization-content-list.tsx';
import OrganizationMediaList from '@/components/media/organization-media-list/organization-media-list.tsx';
import OrganizationEventsList from './components/events/organization-events-list';
import OrganizationTeamListPage from '@/components/organizations/organization-team-list-page';
import OrganizationPlanPage from '@/components/organizations/organization-plan-page';
import EventDetail from './components/events/detail';
import FlowDetail from './components/flows/detail';
import SpaceDetail from './components/spaces/detail/space-detail';
import ContributionsList from './components/user-dashboard/contributions/list-page';
import ContributionDetailsPage from './components/user-dashboard/contributions';
import FeaturesPage from './components/features';
import SwaggerPage from './components/swagger';
import HtmlComponentsPage from './components/admin-player/html-components';
import CompositeComponentsPage from './components/admin-player/composite-components';
import SlideTemplatesPage from './components/admin-player/slide-templates';
import VmAdminPage from './components/vm-admin';
import AgentPoolsAdminPage from './components/agent-pools-admin';
import ProcessorAdminPage from './components/processor-admin';
import SingleCamAgentAdminPage from './components/singlecam-agent-admin';
import MediaAgentAdminPage from './components/media-agent-admin';
import OpsAdminPage from './components/ops-admin';
import ProductsAdminPage from './components/admin-products/products-admin-page';
import SubscriptionPlansAdminPage from './components/admin-subscription-plans/subscription-plans-admin-page';
import CommercialFeaturesAdminPage from './components/admin-commercial-features/commercial-features-admin-page';
import EntitlementsAdminPage from './components/admin-entitlements/entitlements-admin-page';
import RequireAdminLayout from './components/auth/require-admin-layout';

export default function Router() {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="create" element={<Create />} />
      <Route path="organization/:organizationId" element={<div>organization details</div>} />
      <Route path="organization/:organizationId/content" element={<OrganizationContentList />} />
      <Route path="organization/:organizationId/content/:contentId" element={<div>organization content details</div>} />
      <Route path="organization/:organizationId/media" element={<OrganizationMediaList />} />
      <Route path="organization/:organizationId/events" element={<OrganizationEventsList />} />
      <Route path="organization/:organizationId/team" element={<OrganizationTeamListPage />} />
      <Route path="organization/:organizationId/plan" element={<OrganizationPlanPage />} />
      <Route path="event/:eventId" element={<EventDetail />} />
      <Route path="event/:eventId/space/:spaceId" element={<SpaceDetail />} />
      <Route path="flow/:flowId" element={<FlowDetail />} />
      <Route path="contributions" element={<ContributionsList />} />
      <Route path="contributions/:contributorId" element={<ContributionDetailsPage />} />
      <Route element={<RequireAdminLayout />}>
        <Route path="features" element={<FeaturesPage />} />
        <Route path="swagger" element={<SwaggerPage />} />
        <Route path="admin/player/slide-templates" element={<SlideTemplatesPage />} />
        <Route path="admin/player/composite-components" element={<CompositeComponentsPage />} />
        <Route path="admin/player/html-components" element={<HtmlComponentsPage />} />
        <Route path="admin/vm" element={<VmAdminPage />} />
        <Route path="admin/ops" element={<OpsAdminPage />} />
        <Route path="admin/agents" element={<AgentPoolsAdminPage />} />
        <Route path="admin/agents/:tab" element={<AgentPoolsAdminPage />} />
        <Route path="admin/processor" element={<ProcessorAdminPage />} />
        <Route path="admin/singlecam-agent" element={<SingleCamAgentAdminPage />} />
        <Route path="admin/media-agent" element={<MediaAgentAdminPage />} />
        <Route path="admin/products" element={<ProductsAdminPage />} />
        <Route path="admin/subscription-plans" element={<SubscriptionPlansAdminPage />} />
        <Route path="admin/commercial-features" element={<CommercialFeaturesAdminPage />} />
        <Route path="admin/entitlements" element={<EntitlementsAdminPage />} />
      </Route>
    </Routes>
  );
}
